import { ProviderName } from '@fgb/core';
import { PazeExpressCheckoutComponent } from './checkouts/paze/paze-express-checkout.component';
import { FreedomPayComponent } from './checkouts/freedom-pay/freedom-pay.component';
import { PaypalExpressCheckoutComponent } from './checkouts/paypal/paypal.component';

/**
 * Registry of available express checkout provider components. Which of these actually render is
 * controlled per-app via the `expressCheckout.providers` config (EXPRESS_CHECKOUT_ENABLED).
 */
export const defaultExpressCheckoutComponents = {
  [ProviderName.Paze]: { component: PazeExpressCheckoutComponent },
  [ProviderName.FreedomPay]: { component: FreedomPayComponent },
  [ProviderName.PayPal]: { component: PaypalExpressCheckoutComponent },
};
